import type { ExcelColumn } from '../../../utils/excelExport';
import { AUDIT_EXPORT_COLUMNS } from '../../../lib/auditColumnDefs';
import type { StorefrontUrlReviewColumnFilters } from '../models/types';

/** Same columns and visual order as the URL review grid (Action excluded). Status is pinned right. */
export const STOREFRONT_URL_REVIEW_EXPORT_COLUMNS: ExcelColumn[] = [
  { header: 'Merchant', key: 'merchantName' },
  { header: 'URL', key: 'url' },
  { header: 'Reason', key: 'rejectionReason' },
  ...AUDIT_EXPORT_COLUMNS,
  { header: 'Status', key: 'status' },
];

export const SEARCH_DEBOUNCE_MS = 400;

export const EMPTY_STOREFRONT_URL_REVIEW_COLUMN_FILTERS: StorefrontUrlReviewColumnFilters = {
  merchantName: null,
  url: null,
  status: null,
  rejectionReason: null,
  createdAt: null,
};
